import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row, Typography } from 'antd';
import { get } from 'lodash';
import queryString from 'query-string';

import { TableList } from 'components/table-list';
import PdButton from 'components/pd-button';
import PdCsvDownloader from 'components/pd-csv-downloader';
import StatusList from 'components/list-status';

import { priceFormat, WITHDRAWAL_STATUS_FILTER_LIST } from 'utils';

const { Title } = Typography;

const Withdrawal = ({
  fetchWithdrawalForDownload,
  withdrawalForDownload,
  withdrawalList,
  withdrawalLoad,
  withdrawalNext,
  loadMoreWithdrawal,
}) => {
  const orderColumns = [
    {
      name: 'Status',
      selector: row => row.status,
      width: '30%',
    },
    {
      name: 'Message',
      selector: row => row.message,
      width: '40%',
    },
    {
      name: 'Amount',
      selector: row => row.amount,
      width: '30%',
      format: (row) => `IDR  ${priceFormat(get(row, 'amount', ''))}`,
    },
  ];
  const [list, setList] = useState([]);
  const [status, setStatus] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const parsed = queryString.parse(location.search);

  function filterWithdrawal(param, val) {
    if (!val) delete parsed[param];
    else parsed[param] = val;

    navigate('/resellers_active/detail?${stringified}', { replace: true });
  }

  async function handleDownloadCsv() {
    const data = await fetchWithdrawalForDownload();
    return data
  }

  useEffect(() => {
    setList(withdrawalList);
  }, [withdrawalList]);

  useEffect(() => {
    if (parsed['withdrawal_status']) setStatus(parsed['withdrawal_status']);
    else setStatus('');
  }, [parsed]);

  return (
    <Col lg={24} className="section-container pd-reseller-detail-cashback">
      <div className=" inner-section">
        <Row className="summaryContent" type="flex" align="middle">
          <Col lg={24}>
            <Title className="pageSubtitle" level={3}>
              Withdrawal
            </Title>
          </Col>
          <Col lg={24}>
            <Col lg={4} className="mt-2">
              <span>Filter by Status:</span>
            </Col>
            <Col lg={13} className="mt-1">
              <StatusList
                onChange={filterWithdrawal.bind(this, 'withdrawal_status')}
                selectedStatus={status}
                statusList={WITHDRAWAL_STATUS_FILTER_LIST}
              />
            </Col>
            <Col lg={{ span: 4, offset: 2 }} className="pd-margin-top-md">
              {withdrawalList.length > 0 && (
                <PdCsvDownloader
                  datas={handleDownloadCsv}
                  filename={get(
                    withdrawalForDownload,
                    'store_name',
                    'withdrawal-data-homestory'
                  )}
                />
              )}
            </Col>
          </Col>
          <Col lg={24} className="pd-margin-top-md pd-reseller-detail-table">
            <TableList columns={orderColumns} orderList={list} />
          </Col>
          <Col lg={{ span: 3, offset: 10 }}>
            {withdrawalNext > 0 && (
              <PdButton
                onClick={loadMoreWithdrawal.bind(this, true)}
                outline={true}
                type="primary">
                {withdrawalLoad ? 'Loading...' : 'Load More'}
              </PdButton>
            )}
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default Withdrawal;
